import React from "react";
import { CalendarDays, Clock, MapPin } from "lucide-react";
import { SCHEDULE } from "../../mock/mock";

export default function ProgramSchedule() {
  return (
    <section id="schedule" className="relative bg-[#f3ead9]">
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="eyebrow text-lg">{SCHEDULE.eyebrow}</p>
          <div className="mx-auto mt-3 ornament-line" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-[#1a1a1a]">
            {SCHEDULE.heading}
          </h2>
          <p className="mt-4 text-[#1a1a1a]/70">
            Cohort opens Monday 5 October 2026. All live calls run Mondays at 5:00pm AEST unless noted.
          </p>
        </div>

        <div className="mt-14 relative">
          {/* vertical spine */}
          <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-[#c9b993]" />

          <ol className="space-y-8 md:space-y-12">
            {SCHEDULE.weeks.map((w, i) => {
              const isLeft = i % 2 === 0;
              return (
                <li key={w.label} className="relative md:grid md:grid-cols-2 md:gap-10 items-center">
                  {/* Card — alternates sides on md+ */}
                  <div
                    className={
                      isLeft
                        ? "md:col-start-1 md:pr-10 md:flex md:justify-end"
                        : "md:col-start-2 md:pl-10 md:flex md:justify-start"
                    }
                  >
                    <ScheduleCard w={w} />
                  </div>

                  {/* Spine dot */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 items-center justify-center">
                    <div className="h-4 w-4 rounded-full bg-[#7a1e2f] ring-4 ring-[#f3ead9]" />
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}

function ScheduleCard({ w }) {
  const isSydney = w.time.toLowerCase().includes("sydney") || w.date.toLowerCase().includes("sydney");
  return (
    <div className="w-full max-w-md bg-white border border-[#e2d5bb] rounded-2xl p-5 md:p-6 lift">
      <div className="flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase text-[#c9a961]">
        <CalendarDays size={14} />
        <span>{w.label}</span>
      </div>
      <h3 className="mt-2 font-serif-display text-xl md:text-2xl text-[#1a1a1a]">{w.title}</h3>
      <p className="mt-2 text-[14px] text-[#1a1a1a]/70 leading-relaxed">{w.body}</p>
      <div className="mt-4 flex flex-wrap items-center gap-4 text-[12.5px] text-[#1a1a1a]/70">
        <span className="inline-flex items-center gap-1.5">
          <CalendarDays size={13} /> {w.date}
        </span>
        <span className="inline-flex items-center gap-1.5">
          {isSydney ? <MapPin size={13} /> : <Clock size={13} />} {w.time}
        </span>
      </div>
    </div>
  );
}
